import { JsFormResponseHandlerObject } from '../../general/modules/jsFormTypes';
import { JRpcResponse, JsonRpcResponseFactory } from '../../general/modules/jsonRpc/jsonRpcResponseFactory';
import { ErrorToolTip, TooltipDirection } from '../../general/newErrorToolTip';
import { JRpcErrResponse } from '../../general/modules/jsonRpc/jRpcErrResponse';
import { JRpcSuccResponse } from '../../general/modules/jsonRpc/jRpcSuccResponse';
import { disableJsFormHandler } from '../../general/modules/jsForm';
import { Localization } from '../../localization/localization';
import { configureHttpAuth } from '../../startup/configureHttpAuth';

function registrationDoubleDesktop(data: JsFormResponseHandlerObject<JRpcResponse<{}>>) {
    const response = (new JsonRpcResponseFactory<{}>()).getJsonRpcResponseFromObject(data.response);
    const toolTipDirection: keyof typeof TooltipDirection = data.caller.data('tooltipdirection');
    const toolTipDirectionSide: TooltipDirection = TooltipDirection[toolTipDirection];

    if (response instanceof JRpcErrResponse) {
        ErrorToolTip.getTooltipElement().showTooltipElement(
            $('input[name=password]', data.form),
            toolTipDirectionSide as TooltipDirection,
            response.error.message
        );
        return;
    }

    if (response instanceof JRpcSuccResponse) {
        window.app.openDownStep2AndDownload();
        return;
    }

    ErrorToolTip.getTooltipElement().showTooltipElement(
        $('input[name=password]', data.form),
        toolTipDirectionSide as TooltipDirection,
        Localization._n('common_error')
    );
}

async function registrationDoubleSite(data: JsFormResponseHandlerObject<JRpcResponse<{}>>) {
    const response = (new JsonRpcResponseFactory<{
        huid: number
    }>()).getJsonRpcResponseFromObject(data.response);
    const toolTipDirection: keyof typeof TooltipDirection = data.caller.data('tooltipdirection');
    const toolTipDirectionSide: TooltipDirection = TooltipDirection[toolTipDirection];

    if (response instanceof JRpcErrResponse) {
        ErrorToolTip.getTooltipElement().showTooltipElement(
            $('input[name=password]', data.form),
            toolTipDirectionSide as TooltipDirection,
            response.error.message
        );
        return;
    }

    if (response instanceof JRpcSuccResponse) {
        window.app.user_huid = response.result.huid;
        configureHttpAuth();
        window.app.eventInstall();
        disableJsFormHandler(data.form);

        location.reload();
        return;
    }

    ErrorToolTip.getTooltipElement().showTooltipElement(
        $('input[name=password]', data.form),
        toolTipDirectionSide as TooltipDirection,
        Localization._n('common_error')
    );
}

// REGISTRATION DOUBLE DESKTOP
window.app.registrationDoubleDesktop = registrationDoubleDesktop;
window.app.registrationDoubleSite = registrationDoubleSite;
